import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('core-toolbar'),_c(VMain,[_c('div',{attrs:{"id":"core-view"}},[_c(VFadeTransition,{attrs:{"mode":"out-in"}},[_vm._t("default")],2)],1)]),_c('core-snackbar'),_c('core-confirm',{ref:"confirm"}),_c('core-footer',{attrs:{"showLogo":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }